var map = {
	"./esports-bg.webp": 1632,
	"./esports-ctg.webp": 1633,
	"./im-img.webp": 1634,
	"./im-title-cn.webp": 1635,
	"./im-title-en.webp": 1636,
	"./object-1.webp": 1637,
	"./object-2.webp": 1638,
	"./object-3.webp": 1639,
	"./object-4.webp": 1640,
	"./tfg-img.webp": 1641,
	"./tfg-title-cn.webp": 1642,
	"./tfg-title-en.webp": 1643,
	"./title-cn.webp": 1644,
	"./title-en.webp": 1645
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1631;